// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
    --sidebar-width: 343px;
    --sidebar-height: 88vh;
    --sidebar-toggle-btn-width: 24px;
    --sidebar-toggle-btn-height: 80px;
    --sidebar-padding: 20px 18px 20px 16px;
}


.sidebar-active-section{
    padding-right: var(--sidebar-width);
}


.sidebar-start-section{
    position: fixed;
    min-width: var(--sidebar-width);
    right: 0;
    height: var(--sidebar-height);
    background: transparent linear-gradient(180deg, #AAE7FF 0%, #F4FCFF 20%) 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 10px #0000004D;
    transition: all 0.5s;
    margin-right: var(--body-scrollbar-width);
    z-index: 5;
}
.sidebar-start-section.sidebar-inactive-section{
    transform: translateX(var(--sidebar-width));
    transition: all 0.5s;
    margin-right: 0;
}

.sidebar-toggle-btn-section{
    position: absolute;
    width: var(--sidebar-toggle-btn-width);
    height: var(--sidebar-toggle-btn-height);
    left: calc(-1 * var(--sidebar-toggle-btn-width));
    background: var(--call-to-action1) 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #0000004D;
    border-radius: 6px 0px 0px 6px;
    display: grid;
    justify-items: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.5s;
}

.sidebar-toggle-btn-section:hover{
    background-color: var(--call-to-action2);
    transition: all 0.5s;
}

.sidebar-content-section{
    height: 100%;
    width: 100%;
    display: grid;
    padding: var(--sidebar-padding);
    grid-template-rows: 1fr 1fr 10fr;
    grid-row-gap: 9px;
    overflow: scroll;
}

.sidebar-content-section .sidebar-content-group-section:first-child{
    font: normal normal 16px/19px Lato;
    letter-spacing: 0.16px;
    color: var(--neutral-color7);
    cursor: default;
}
.sidebar-content-section .sidebar-content-group-section:first-child span:last-child{
    font: normal normal 22px/27px Lato;
    letter-spacing: 0.22px;
}
.sidebar-content-section .sidebar-content-group-section:last-child{
    display: grid;
    grid-template-rows: repeat(3, 1fr);
    grid-row-gap: 10px;
}
.sidebar-content-group-item-section{
    display: grid;
    grid-template-rows: 0.1fr 1fr;
    grid-row-gap: 10px;
}
.sidebar-content-group-item-section .sidebar-content-group-item:first-child{
    font: normal normal bold 16px/19px Lato;
    letter-spacing: 0.16px;
    color: var(--neutral-color7);
    padding: 6px 15px;
    position: relative;
    display: grid;
    align-items: center;
    border-bottom: 1px solid var(--neutral-color3);
    cursor: default;
}
.sidebar-content-group-item-section .sidebar-content-group-item:first-child::before{
    content: "";
    width: 7px;
    height: 7px;
    border-radius: 50%;
    position: absolute;
    background: var(--neutral-color7) 0% 0% no-repeat padding-box;
    left: 0;
}
.sidebar-content-group-item-section .sidebar-content-group-item:nth-child(2){
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 7px;
}
.sidebar-content-group-item-section .sidebar-content-group-item:nth-child(2) .sidebar-content-group-sub-item-section{
    display: grid;
    grid-template-rows: 0.1fr 1fr;
    grid-row-gap: 10px;
}

.sidebar-content-group-item-section .sidebar-content-group-item:nth-child(2) .sidebar-content-group-sub-item:first-child{
    font: normal normal 12px/15px Lato;
    letter-spacing: 0.12px;
    color: var(--neutral-color6);
    text-align: center;
    cursor: default;
}
.sidebar-content-group-item-section .sidebar-content-group-item:nth-child(2) .sidebar-content-group-sub-item:last-child{
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 4px var(--border-shadow-color4);
    border-radius: 6px;
    padding: 9px 10px;
    display: grid;
    align-items: center;
    grid-row-gap: 2px;
    border: 1px solid var(--neutral-color1);
    cursor: pointer;
    transition: all 0.6s;
}
.sidebar-content-group-item-section .sidebar-content-group-item:nth-child(2) .sidebar-content-group-sub-item-section:hover .sidebar-content-group-sub-item:first-child{
    color: var(--text-color2);
    transition: all 0.6s;
}
.sidebar-content-group-item-section .sidebar-content-group-item:nth-child(2) .sidebar-content-group-sub-item:last-child:hover{
    border: 1px solid var(--call-to-action1);
    transition: all 0.6s;
}

.sidebar-content-group-item-section .sidebar-content-group-item:nth-child(2) .sidebar-content-group-sub-item:last-child .sidebar-content-group-sub-item-value:first-child{
    font: normal normal 22px/27px Lato;
    letter-spacing: 0.22px;
    border-bottom: 1px solid var(--neutral-color3);
}
.sidebar-content-group-item-section .sidebar-content-group-item:nth-child(2) .sidebar-content-group-sub-item:last-child .sidebar-content-group-sub-item-value:last-child{
    font: normal normal bold 14px/17px Lato;
    letter-spacing: 0.14px;
    color: var(--neutral-color6);
}

.sidebar-color-yellow .sidebar-content-group-sub-item-value:first-child{
    color: var(--indicators-yellow);
}
.sidebar-color-red .sidebar-content-group-sub-item-value:first-child{
    color: var(--indicators-red);
}
.sidebar-color-green .sidebar-content-group-sub-item-value:first-child{
    color: var(--indicators-green);
}
.sidebar-color-blue .sidebar-content-group-sub-item-value:first-child{
    color: var(--call-to-action1);
}

/* --------- Mobile Design ----------- */
@media screen and (max-width:992px) {
    :root{
        --sidebar-height: 89.7vh;
        --sidebar-width: -webkit-calc(100% - 24px)
    }
    .sidebar-start-section.sidebar-inactive-section{
        transform: translateX(var(--sidebar-width)+var(--body-scrollbar-width));
        min-width: 0%;
        transform: translateX(100%);
        transition: all 0.8s;
    }
    .sidebar-start-section{
        margin-right: 0;
    }
    .sidebar-inactive-section .sidebar-content-section{
        display: none;
    }
    .sidebar-content-section .sidebar-content-group-section:first-child,
    .sidebar-content-section .sidebar-content-group-section:first-child span:last-child{
        font: normal normal 21px/25px Lato;
        letter-spacing: 0.21px;
    }
    .sidebar-content-section .sidebar-content-group-section:first-child br{
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/CSS/SupervisorSummary.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,gCAAgC;IAChC,iCAAiC;IACjC,sCAAsC;AAC1C;;;AAGA;IACI,mCAAmC;AACvC;;;AAGA;IACI,eAAe;IACf,+BAA+B;IAC/B,QAAQ;IACR,6BAA6B;IAC7B,oGAAoG;IACpG,kCAAkC;IAClC,oBAAoB;IACpB,yCAAyC;IACzC,UAAU;AACd;AACA;IACI,2CAA2C;IAC3C,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,wCAAwC;IACxC,gDAAgD;IAChD,8DAA8D;IAC9D,iCAAiC;IACjC,8BAA8B;IAC9B,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,wCAAwC;IACxC,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,+BAA+B;IAC/B,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,4BAA4B;IAC5B,eAAe;AACnB;AACA;IACI,kCAAkC;IAClC,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,kCAAkC;IAClC,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;AACtB;AACA;IACI,uCAAuC;IACvC,sBAAsB;IACtB,4BAA4B;IAC5B,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8CAA8C;IAC9C,eAAe;AACnB;AACA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,6DAA6D;IAC7D,OAAO;AACX;AACA;IACI,aAAa;IACb,qCAAqC;IACrC,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,6DAA6D;IAC7D,mDAAmD;IACnD,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,uCAAuC;IACvC,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,yBAAyB;IACzB,oBAAoB;AACxB;AACA;IACI,wCAAwC;IACxC,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,8CAA8C;AAClD;AACA;IACI,uCAAuC;IACvC,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,+BAA+B;AACnC;AACA;IACI,4BAA4B;AAChC;AACA;IACI,8BAA8B;AAClC;AACA;IACI,6BAA6B;AACjC;;AAEA,wCAAwC;AACxC;IACI;QACI,wBAAwB;QACxB;IACJ;IACA;QACI,uEAAuE;QACvE,aAAa;QACb,2BAA2B;QAC3B,oBAAoB;IACxB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;;QAEI,kCAAkC;QAClC,sBAAsB;IAC1B;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":[":root{\r\n    --sidebar-width: 343px;\r\n    --sidebar-height: 88vh;\r\n    --sidebar-toggle-btn-width: 24px;\r\n    --sidebar-toggle-btn-height: 80px;\r\n    --sidebar-padding: 20px 18px 20px 16px;\r\n}\r\n\r\n\r\n.sidebar-active-section{\r\n    padding-right: var(--sidebar-width);\r\n}\r\n\r\n\r\n.sidebar-start-section{\r\n    position: fixed;\r\n    min-width: var(--sidebar-width);\r\n    right: 0;\r\n    height: var(--sidebar-height);\r\n    background: transparent linear-gradient(180deg, #AAE7FF 0%, #F4FCFF 20%) 0% 0% no-repeat padding-box;\r\n    box-shadow: 0px 0px 10px #0000004D;\r\n    transition: all 0.5s;\r\n    margin-right: var(--body-scrollbar-width);\r\n    z-index: 5;\r\n}\r\n.sidebar-start-section.sidebar-inactive-section{\r\n    transform: translateX(var(--sidebar-width));\r\n    transition: all 0.5s;\r\n    margin-right: 0;\r\n}\r\n\r\n.sidebar-toggle-btn-section{\r\n    position: absolute;\r\n    width: var(--sidebar-toggle-btn-width);\r\n    height: var(--sidebar-toggle-btn-height);\r\n    left: calc(-1 * var(--sidebar-toggle-btn-width));\r\n    background: var(--call-to-action1) 0% 0% no-repeat padding-box;\r\n    box-shadow: 0px 0px 6px #0000004D;\r\n    border-radius: 6px 0px 0px 6px;\r\n    display: grid;\r\n    justify-items: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    transition: all 0.5s;\r\n}\r\n\r\n.sidebar-toggle-btn-section:hover{\r\n    background-color: var(--call-to-action2);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.sidebar-content-section{\r\n    height: 100%;\r\n    width: 100%;\r\n    display: grid;\r\n    padding: var(--sidebar-padding);\r\n    grid-template-rows: 1fr 1fr 10fr;\r\n    grid-row-gap: 9px;\r\n    overflow: scroll;\r\n}\r\n\r\n.sidebar-content-section .sidebar-content-group-section:first-child{\r\n    font: normal normal 16px/19px Lato;\r\n    letter-spacing: 0.16px;\r\n    color: var(--neutral-color7);\r\n    cursor: default;\r\n}\r\n.sidebar-content-section .sidebar-content-group-section:first-child span:last-child{\r\n    font: normal normal 22px/27px Lato;\r\n    letter-spacing: 0.22px;\r\n}\r\n.sidebar-content-section .sidebar-content-group-section:last-child{\r\n    display: grid;\r\n    grid-template-rows: repeat(3, 1fr);\r\n    grid-row-gap: 10px;\r\n}\r\n.sidebar-content-group-item-section{\r\n    display: grid;\r\n    grid-template-rows: 0.1fr 1fr;\r\n    grid-row-gap: 10px;\r\n}\r\n.sidebar-content-group-item-section .sidebar-content-group-item:first-child{\r\n    font: normal normal bold 16px/19px Lato;\r\n    letter-spacing: 0.16px;\r\n    color: var(--neutral-color7);\r\n    padding: 6px 15px;\r\n    position: relative;\r\n    display: grid;\r\n    align-items: center;\r\n    border-bottom: 1px solid var(--neutral-color3);\r\n    cursor: default;\r\n}\r\n.sidebar-content-group-item-section .sidebar-content-group-item:first-child::before{\r\n    content: \"\";\r\n    width: 7px;\r\n    height: 7px;\r\n    border-radius: 50%;\r\n    position: absolute;\r\n    background: var(--neutral-color7) 0% 0% no-repeat padding-box;\r\n    left: 0;\r\n}\r\n.sidebar-content-group-item-section .sidebar-content-group-item:nth-child(2){\r\n    display: grid;\r\n    grid-template-columns: repeat(4, 1fr);\r\n    grid-column-gap: 7px;\r\n}\r\n.sidebar-content-group-item-section .sidebar-content-group-item:nth-child(2) .sidebar-content-group-sub-item-section{\r\n    display: grid;\r\n    grid-template-rows: 0.1fr 1fr;\r\n    grid-row-gap: 10px;\r\n}\r\n\r\n.sidebar-content-group-item-section .sidebar-content-group-item:nth-child(2) .sidebar-content-group-sub-item:first-child{\r\n    font: normal normal 12px/15px Lato;\r\n    letter-spacing: 0.12px;\r\n    color: var(--neutral-color6);\r\n    text-align: center;\r\n    cursor: default;\r\n}\r\n.sidebar-content-group-item-section .sidebar-content-group-item:nth-child(2) .sidebar-content-group-sub-item:last-child{\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    box-shadow: 0px 0px 4px var(--border-shadow-color4);\r\n    border-radius: 6px;\r\n    padding: 9px 10px;\r\n    display: grid;\r\n    align-items: center;\r\n    grid-row-gap: 2px;\r\n    border: 1px solid var(--neutral-color1);\r\n    cursor: pointer;\r\n    transition: all 0.6s;\r\n}\r\n.sidebar-content-group-item-section .sidebar-content-group-item:nth-child(2) .sidebar-content-group-sub-item-section:hover .sidebar-content-group-sub-item:first-child{\r\n    color: var(--text-color2);\r\n    transition: all 0.6s;\r\n}\r\n.sidebar-content-group-item-section .sidebar-content-group-item:nth-child(2) .sidebar-content-group-sub-item:last-child:hover{\r\n    border: 1px solid var(--call-to-action1);\r\n    transition: all 0.6s;\r\n}\r\n\r\n.sidebar-content-group-item-section .sidebar-content-group-item:nth-child(2) .sidebar-content-group-sub-item:last-child .sidebar-content-group-sub-item-value:first-child{\r\n    font: normal normal 22px/27px Lato;\r\n    letter-spacing: 0.22px;\r\n    border-bottom: 1px solid var(--neutral-color3);\r\n}\r\n.sidebar-content-group-item-section .sidebar-content-group-item:nth-child(2) .sidebar-content-group-sub-item:last-child .sidebar-content-group-sub-item-value:last-child{\r\n    font: normal normal bold 14px/17px Lato;\r\n    letter-spacing: 0.14px;\r\n    color: var(--neutral-color6);\r\n}\r\n\r\n.sidebar-color-yellow .sidebar-content-group-sub-item-value:first-child{\r\n    color: var(--indicators-yellow);\r\n}\r\n.sidebar-color-red .sidebar-content-group-sub-item-value:first-child{\r\n    color: var(--indicators-red);\r\n}\r\n.sidebar-color-green .sidebar-content-group-sub-item-value:first-child{\r\n    color: var(--indicators-green);\r\n}\r\n.sidebar-color-blue .sidebar-content-group-sub-item-value:first-child{\r\n    color: var(--call-to-action1);\r\n}\r\n\r\n/* --------- Mobile Design ----------- */\r\n@media screen and (max-width:992px) {\r\n    :root{\r\n        --sidebar-height: 89.7vh;\r\n        --sidebar-width: -webkit-calc(100% - 24px)\r\n    }\r\n    .sidebar-start-section.sidebar-inactive-section{\r\n        transform: translateX(var(--sidebar-width)+var(--body-scrollbar-width));\r\n        min-width: 0%;\r\n        transform: translateX(100%);\r\n        transition: all 0.8s;\r\n    }\r\n    .sidebar-start-section{\r\n        margin-right: 0;\r\n    }\r\n    .sidebar-inactive-section .sidebar-content-section{\r\n        display: none;\r\n    }\r\n    .sidebar-content-section .sidebar-content-group-section:first-child,\r\n    .sidebar-content-section .sidebar-content-group-section:first-child span:last-child{\r\n        font: normal normal 21px/25px Lato;\r\n        letter-spacing: 0.21px;\r\n    }\r\n    .sidebar-content-section .sidebar-content-group-section:first-child br{\r\n        display: none;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
